import { displayValue } from '@/helpers/orgSearch'
import { Text } from '@chakra-ui/react'
import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { type ConfirmedOrgState, useConfirmedOrg } from './useConfirmedOrg'

function tagText(orgId: string, state: ConfirmedOrgState, t: TFunction) {
  switch (state.status) {
    case 'pending':
      return String(t('orgFilter.tag.pending', { orgId }))
    case 'confirmed':
      return String(
        t('orgFilter.tag.confirmed', {
          name: displayValue(state.org.name),
          orgId,
        }),
      )
    case 'unconfirmed':
      return String(t('orgFilter.tag.unconfirmed', { orgId }))
  }
}

export function OrgFilterTagValue({ orgId }: Readonly<{ orgId: string }>) {
  const { t } = useTranslation('features', { useSuspense: false })
  const text = tagText(orgId, useConfirmedOrg(orgId), t)
  return (
    <Text
      as="span"
      display="inline-block"
      maxWidth="320px"
      truncate
      verticalAlign="bottom"
      title={text}
    >
      {text}
    </Text>
  )
}
